import { render, staticRenderFns } from "./SideNavExtraLinks.vue?vue&type=template&id=5ade1c42&"
import script from "./SideNavExtraLinks.vue?vue&type=script&lang=js&"
export * from "./SideNavExtraLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports